/* eslint-disable no-redeclare */
import type { JourneyAlias } from '@hc-frontend/core-types';
import { z } from 'zod';

export const JourneyPaths = z.enum([
  'healthcare-insurance',
  'medicare',
  'medicare-advantage',
  'medicare-supplement',
  'life-insurance',
]);

export type JourneyPaths = z.infer<typeof JourneyPaths>;

export const journeyAliasToPath: Record<JourneyAlias, JourneyPaths> = {
  HEALTH_DEFAULT: 'healthcare-insurance',
  MEDICARE_GENERIC: 'medicare',
  MEDICARE_ADVANTAGE: 'medicare-advantage',
  MEDICARE_SUPPLEMENT: 'medicare-supplement',
  LIFE_INSURANCE: 'life-insurance',
  '112': 'healthcare-insurance',
};
